import React, { Fragment } from 'react';
import { Textbox, Button, DateRangePicker, SelectMenu, Checkbox, RangeSlider } from 'components/generic';
import { map } from 'lodash';
import './style.scss';

export default function FormRenderer(props) {
	const { formObj, handleBlur, errors, handleSubmit, handleOnChange } = props;
	const getSelectedOptions = e => e?.map(name => ({ label: name, value: name }));

	return (
		<>
			{map(formObj, (el, i) => (
				<React.Fragment key={i}>
					{['number', 'string', 'password', 'textbox']?.includes(el?.data_type) && (
						<div className='form-renderer__container'>
							<Textbox
								name={el?.field_key}
								type={el?.data_type}
								id={el?.field_key}
								label={el?.label}
								placeholder={el?.placeholder}
								value={el?.value}
								onChange={e => handleOnChange({ e: e.target.value, key: el?.field_key, type: el?.data_type })}
								alignLabel={el?.alignLabel}
								mandatory={el?.mandatory}
								onBlur={handleBlur}
								errorMessage={el?.errors}
								error={errors?.hasOwnProperty(el?.field_key)}
								readonly={el.readOnly}
							/>
						</div>
					)}
					{el?.data_type === 'button' && (
						<div className='form-renderer__container'>
							<div className='btn'>
								{map(el?.data, (elm, ind) => (
									<Fragment key={ind}>
										<Button
											widthClass={el?.style}
											disabled={elm?.disabled}
											type={elm?.field_key}
											label={elm?.label}
											small={elm.small}
											xsmall={elm.xsmall}
											transparent={elm?.transparent}
											primary={true}
											handleOnSubmit={e => handleSubmit({ e, field_key: elm?.field_key })}
											last={elm?.last}
										/>
									</Fragment>
								))}
							</div>
						</div>
					)}

					{el?.data_type === 'date' && (
						<div className='form-renderer__container'>
							<DateRangePicker
								value={el?.value}
								label={el?.label}
								onChange={e => {
									handleOnChange({ e, key: el?.field_key, type: el?.data_type });
								}}
							/>
						</div>
					)}

					{el.data_type === 'dropdown' && (
						<div className='form-renderer__container'>
							<SelectMenu
								label={el.label}
								options={el.options}
								alignLeft={el.alignLeft}
								mandatory={el.mandatory}
								isMulti={el?.isMulti}
								value={getSelectedOptions(el.value)}
								onChange={e => handleOnChange({ e, key: el.field_key, data_type: el.data_type })}
							/>
						</div>
					)}

					{el?.data_type === 'amount' && (
						<div className='form-renderer__container'>
							<RangeSlider
								range
								min={el?.minRangeValue}
								max={el?.maxRangeValue}
								defaultValue={[el?.minRangeValue, el?.maxRangeValue]}
								label={el?.label}
								value={el?.value}
								onChange={e => handleOnChange({ e: e, key: el?.field_key, data_type: el?.data_type, state: 'range' })}
							/>
						</div>
					)}

					{el.data_type === 'checkbox' && (
						<Checkbox widthClass={el?.style} type='checkbox' label='Status' checked={el?.checked} mandatory={true} data={el?.data} onClick={e => handleOnChange({ e, field_key: el?.field_key, data_type: el?.data_type })} />
					)}
				</React.Fragment>
			))}
		</>
	);
}
